/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiFrameSizeMaxIcon20Light = forwardRef('UiFrameSizeMaxIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12 2.5a.5.5 0 0 1 .5-.5h2.75A2.75 2.75 0 0 1 18 4.75V7.5a.5.5 0 0 1-1 0V4.75A1.75 1.75 0 0 0 15.25 3H12.5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M3 12.5a.5.5 0 0 0-1 0v2.75A2.75 2.75 0 0 0 4.75 18H7.5a.5.5 0 0 0 0-1H4.75A1.75 1.75 0 0 1 3 15.25V12.5Z" }),
        React.createElement("path", { d: "M18 12.5a.5.5 0 0 0-1 0v2.75A1.75 1.75 0 0 1 15.25 17H12.5a.5.5 0 0 0 0 1h2.75A2.75 2.75 0 0 0 18 15.25V12.5Z" }),
        React.createElement("path", { d: "M4.75 2A2.75 2.75 0 0 0 2 4.75V7.5a.5.5 0 0 0 1 0V4.75C3 3.784 3.784 3 4.75 3H7.5a.5.5 0 0 0 0-1H4.75Z" })));
});
